import AppConfig from '../AppConfig';

/** Build a Compliance Education API path or absolute URL (supports Vite `/compliance-education-api` proxy). */
export function buildComplianceEducationApiUrl(path: string): string {
  const base = AppConfig.complianceEducationApiUrl.replace(/\/$/, '');
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${suffix}`;
}

/** URL for query-string APIs (searchParams) — works with same-origin Vite proxy base paths. */
export function toComplianceEducationApiUrl(path: string): URL {
  const href = buildComplianceEducationApiUrl(path);
  return href.startsWith('http') ? new URL(href) : new URL(href, window.location.origin);
}
